import React, { Component, PropTypes } from 'react';
import { Icon, Card, Button, Modal, Row, Col, Spin, Alert, Input, Form, Select, DatePicker, Checkbox } from 'antd';

import _ from 'lodash';

import { browserHistory } from 'react-router';
import cn from 'classnames';
import moment from 'moment';
import { formItemLayout } from 'constants/layout';

import { noImage } from 'constants/shared';
import { connect } from 'react-redux';
import { editUser, verifyUser, rejectUser, getPointList, getSpentPointList } from 'data/user';

import classes from '../styles/student/StudentInfo.module.scss';

const genders = {
  male: 'เพศชาย',
  female: 'เพศหญิง',
};
const Option = Select.Option;
const FormItem = Form.Item;
const TextArea = Input.TextArea;

class StudentInfoTab extends Component {
  constructor(props) {
    super(props);
    this.onToggleMode = this.onToggleMode.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.handleVerify = this.handleVerify.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.handleCloseImage = this.handleCloseImage.bind(this);
    this.showImageModal = this.showImageModal.bind(this);

    this.state = {
      collapseMobile: [],
      isPreview: true,
      showModal: false,
    };
  }

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }

  onEditorStateChange(editorState, key) {
    this.setState({
      [key]: editorState,
    });
  }

  showImageModal(url) {
    this.setState({
      showModal: true,
      imageUrl: url,
    });
  }

  handleUpdateProfile(id) {
    const props = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log('Received values of form: ', values);
      if (!err) {
        const newUser = _.merge(values, {});
        editUser(id, newUser).then(() => {
          this.props.reloadData();
          this.setState({ isPreview: true });
        });

        console.log('Received values of form: ', values);
      }
    });
  }

  handleVerify = () => {
    const id = this.props.user._id;
    verifyUser(id).then(() => {
      this.props.reloadData();
    });
  };

  handleReject = () => {
    const id = this.props.user._id;
    rejectUser(id).then(() => {
      this.props.reloadData();
    });
  };

  handleCloseImage() {
    this.setState({
      showModal: false,
      imageUrl: '',
    });
  }

  renderModal() {
    const imageUrl = this.state.imageUrl;

    if (!this.state.showModal) {
      return <div />;
    }
    return (
      <Modal width="960px" className={classes.imageModal} title="" visible={this.state.showModal} onCancel={this.handleCloseImage} footer={null}>
        <img src={imageUrl} />
      </Modal>
    );
  }

  renderPreviewItem(title, value, isBlockContent) {
    let contentSize = 18;
    let titleSize = 6;
    if (isBlockContent) {
      contentSize = 24;
      titleSize = 24;
    }
    return (
      <Row className={'ant-form-item'}>
        <Col className={cn('form-preview-title bold', { 'text-left': isBlockContent })} sm={titleSize}>
          <label>{title}</label>
        </Col>
        <Col className={cn('form-preview-content')} sm={contentSize}>
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </Col>
      </Row>
    );
  }

  renderPreviewMode() {
    const { user } = this.props;
    const age = moment().diff(moment(user.birthday), 'years');
    const checkedEl = <Icon type="check" className="green bold" />;
    const closedEl = <Icon type="close" className="red bold" />;

    const setting = (
      <div>
        <div>{user.allowAccessFullName ? checkedEl : closedEl} แสดงรูปและชื่อในส่วนรีวิว</div>
        <div>{user.allowAccessProfile ? checkedEl : closedEl} อนุญาตให้คนอื่นเข้าชมโปรไฟล์ของฉัน</div>
      </div>
    );

    return (
      <div>
        <div className={'text-right pointer'} onClick={() => this.setState({ isPreview: false })}>
          <Icon type="edit" /> Edit
        </div>
        {this.renderPreviewItem('เบอร์ติดต่อ: ', user.phone)}
        {this.renderPreviewItem('อีเมล: ', user.email)}
        {this.renderPreviewItem('เพศ: ', genders[user.gender])}
        {this.renderPreviewItem('วันเกิด: ', moment(user.birthday).format('DD/MM/YYYY'))}
        {this.renderPreviewItem('อายุ: ', age)}
        {this.renderPreviewItem('จังหวัด: ', user.province)}

        <Row className={'ant-form-item'}>
          <Col className="form-preview-title bold" sm={6}>
            <label>การตั้งค่า: </label>
          </Col>
          <Col className={cn('form-preview-content')} sm={18}>
            {setting}
          </Col>
        </Row>

        <Form onSubmit={this.handleSubmit}>
          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="danger" size="large" onClick={this.handleReject} loading={this.props.loading}>
              Reject
            </Button>
            <Button type="success" size="large" onClick={this.handleVerify} loading={this.props.loading}>
              Approve
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  renderEditorMode() {
    const { getFieldDecorator } = this.props.form;
    const { user } = this.props;
    return (
      <div>
        <div className={'text-right pointer red'} onClick={() => this.setState({ isPreview: true })}>
          <Icon type="close" /> Cancel Edit
        </div>
        <Form onSubmit={this.handleVerify}>
          <FormItem {...formItemLayout} hasFeedback label="เบอร์ติดต่อ">
            {getFieldDecorator('phone', {
              rules: [
                {
                  required: true,
                  message: 'Please input เบอร์ติดต่อ',
                },
              ],
              initialValue: _.get(user, 'phone'),
            })(<Input placeholder="เบอร์ติดต่อ" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="อีเมล">
            {getFieldDecorator('email', {
              rules: [
                {
                  required: true,
                  message: 'Please input อีเมล',
                },
              ],
              initialValue: _.get(user, 'email'),
            })(<Input placeholder="อีเมล" />)}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="เพศ">
            {getFieldDecorator('gender', {
              rules: [
                {
                  required: true,
                  message: 'Please input เพศ',
                },
              ],
              initialValue: _.get(user, 'gender'),
            })(
              <Select placeholder="เพศ">
                <Option value={'male'}>ชาย</Option>
                <Option value={'female'}>หญิง</Option>
              </Select>,
            )}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="วันเกิด">
            {getFieldDecorator('birthday', {
              rules: [
                {
                  required: true,
                  message: 'Please input วันเกิด',
                },
              ],
              initialValue: moment(_.get(user, 'birthday')),
            })(<DatePicker placeholder="วันเกิด" />)}
          </FormItem>

          <FormItem {...formItemLayout} colon={false} label=" ">
            {getFieldDecorator('allowAccessFullName', {
              valuePropName: 'checked',
              initialValue: _.get(user, 'allowAccessFullName'),
            })(<Checkbox>แสดงรูปและชื่อในส่วนรีวิว</Checkbox>)}
          </FormItem>

          <FormItem {...formItemLayout} colon={false} label=" ">
            {getFieldDecorator('allowAccessProfile', {
              valuePropName: 'checked',
              initialValue: _.get(user, 'allowAccessProfile'),
            })(
              <Checkbox>
                อนุญาตให้คนอื่นเข้าชมโปรไฟล์ของฉัน {_.get(user, 'allowAccessFullName')} {_.get(user, 'allowAccessProfile')}
              </Checkbox>,
            )}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="Remark">
            {getFieldDecorator('remark', {
              initialValue: user.remark,
            })(<TextArea placeholder="Remark" />)}
          </FormItem>

          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="primary" size="large" onClick={() => this.handleUpdateProfile(user._id)} loading={this.props.loading}>
              Save
            </Button>
            <Button type="danger" size="large" onClick={() => this.setState({ isPreview: true })}>
              Cancel
            </Button>
          </div>

          <br />
        </Form>
      </div>
    );
  }

  render() {
    // console.log(this.state.files);
    const { loading, user } = this.props;
    if (!user) {
      return <div></div>;
    }

    return (
      <div>
        {
          // <div>
          //    <Button type="primary" onClick={this.onToggleMode}> {this.state.mode === 'editor' ? 'Editor' : 'Preview'}</Button>
          //  </div>
        }
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <Row className="with-margin-top">
            <Col xs={16} span={16} className="with-padding-right">
              <Card bordered={false} noHovering={true}>
                {this.state.isPreview ? this.renderPreviewMode() : this.renderEditorMode()}
              </Card>
            </Col>
            <Col span={8} className="with-padding-left">
              <Card bordered={false} noHovering={true}>
                <span className={'field-title'}>รูปบัตรประชาชน</span>
                <div className={classes.evidence}>
                  <img src={user.idCardImage || noImage} alt="" onClick={() => user.idCardImage && this.showImageModal(user.idCardImage)} />
                </div>
              </Card>
              <Card bordered={false} noHovering={true} className="with-margin">
                <span className={'field-title'}>รูปถ่ายตัวเองคู่กับบัตรประชาชน</span>
                <div className={classes.evidence}>
                  <img src={user.idCardWithFaceImage || noImage} alt="" onClick={() => user.idCardWithFaceImage && this.showImageModal(user.idCardWithFaceImage)} />
                </div>
              </Card>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}
export default connect()(Form.create()(StudentInfoTab));
